// Color theme
export const blue = "#7149C6";
export const red = "#FC2947";
export const orange = "#FE6244";
export const pale = "#FFDEB9";
export const black = "#282828";
